import { ModuleNames } from '@ag-grid-community/core';
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core';
import { DateTimeCellEditor } from './dateTimeCellEditor/dateTimeCellEditor';
export var DateTimeCellEditorModule = {
    moduleName: ModuleNames.DateTimeCellEditorModule,
    beans: [],
    userComponents: [
        { componentName: 'agDateTimeCellEditor', componentClass: DateTimeCellEditor },
    ],
    dependantModules: [EnterpriseCoreModule],
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/date-time-cell-editor/dist/es6/dateTimeCellEditorModule.js
// module id = null
// module chunks = 